module.exports = __webpack_public_path__ + "stylesheets/m-wave-typography_4cc1724c61357c7ff117bee49203141c.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/mobile/wave/m-wave-typography.less
// module id = BTge
// module chunks = 55